import * as Sentry from "@sentry/node";
import Axios from "axios";

import { IInspectorContactFormData } from "@/sections/InspectorContactSection/types";
import { BACKEND_ENDPOINTS } from "../constants/backend";

export const sendContactForm = (params: IInspectorContactFormData) => {
  const formData = new FormData();

  Object.entries(params).forEach(([key, value]) => {
    if (typeof value !== "string") {
      formData.append(key, value!.toString());
    } else {
      formData.append(key, value);
    }
  });

  return Axios.post(BACKEND_ENDPOINTS.contactForm, formData, {
    withCredentials: false,
  }).catch(error => {
    Sentry.withScope(scope => {
      scope.setExtras(
        Object.entries(params).reduce((acc, field) => {
          const [key, value] = field;
          return {
            ...acc,
            [key]: typeof value !== "string" ? value.toString() : value,
          };
        }, {}),
      );
      scope.setTag("where", "Services: contact");
      Sentry.captureException(error);
    });
  });
};
